import React from 'react';

import Show from 'components/Show';
import Container from 'components/Misc/Container';
import { Datepicker } from 'components/Misc/Form';

import { useArticleProfileStore } from 'store/article/useArticleProfileStore';

const Accessability = () => {
	// Use article's profile store
	const article = useArticleProfileStore(state => state.article);

	// Do not show widget if no data
	if (!article.availableFrom && !article.availableUntil) return null;

	return (
		<Container className="p-4 space-y-2">
			<Show if={article.availableFrom}>
				<Datepicker
					readOnly
					label="Redzams no"
					value={article.availableFrom}
				/>
			</Show>

			<Show if={article.availableUntil}>
				<Datepicker
					readOnly
					label="Redzams līdz"
					value={article.availableUntil}
				/>
			</Show>
		</Container>
	);
};

export default Accessability;